module.exports = __webpack_public_path__ + "static/media/heimerl.95cc7c57.svg";